<p-tabView (onChange)="onTabChange($event)">
  <p-tabPanel header="Dashboard">
    <div class="dashboard-container">
      <div class="profile-section">
        <div class="profile-card">
          <div class="profile-header">
            <img src="assets/person-logo.jpg" alt="Profile" class="profile-pic" />
            <div class="profile-info">
              <h3 class="username">{{ employeeName }}</h3>
              <p class="designation">{{ Designation }}</p>
            </div>
          </div>
          <div class="profile-status">
            <p class="checkin-status" [ngClass]="checkedIn ? 'active' : (canCheckIn ? 'inactive' : 'completed')">
              {{ checkedIn ? 'Checked In'
              : (canCheckIn ? 'Yet to Check-in'
              : 'Attendance Completed for Today') }}
            </p>
            <div *ngIf="currentWorkLocationType" class="location-badge-row">
              <p-tag [value]="currentLocationName || currentWorkLocationType"
                [severity]="getWorkTypeBadgeSeverity(currentWorkLocationType)"
                [icon]="getWorkTypeIcon(currentWorkLocationType)">
              </p-tag>
              <p-tag *ngIf="isPendingApproval" value="Pending Approval" severity="warning" icon="pi pi-clock"
                class="ml-1">
              </p-tag>
            </div>
            <div class="timer" *ngIf="checkedIn">
              <span>{{ hours < 10 ? '0' + hours : hours }}</span> :
                  <span>{{ minutes < 10 ? '0' + minutes : minutes }}</span> :
                      <span>{{ seconds < 10 ? '0' + seconds : seconds }}</span>
            </div>
            <div class="button-group">
              <button pButton type="button" [label]="checkedIn ? 'Checked In' : 'Check-in'"
                class="p-button-rounded p-button-success" [disabled]="!canCheckIn || checkedIn" (click)="onCheckIn()"
                [pTooltip]="!canCheckIn ? 'Attendance already completed for today' : ''">
              </button>
              <button *ngIf="checkedIn && canCheckOut" pButton type="button" label="Check-out"
                class="p-button-rounded p-button-danger ml-2" (click)="confirmCheckout()">
              </button>
            </div>
          </div>
        </div>
        <div class="reportees-card">
          <div class="reportees-header">
            <h3>Reporting Manager</h3>
            <span class="count">{{ reportees.length }}</span>
          </div>
          <div class="reportees">
            <div *ngFor="let rep of reportees" class="reportee-card">
              <img src="assets/person-logo.jpg" [alt]="rep.name" class="avatar" />
              <div class="reportee-info">
                <div class="name">{{ rep.name }}</div>
                <div class="designation">{{ rep.designation }}</div>
              </div>
              <span class="status-badge" [ngClass]="rep.status === 'Active' ? 'active' : 'inactive'">
                {{ rep.status }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="main-section">
        <div class="birthday-hero" *ngIf="isMyBirthdayToday">
          <div class="hero-content">
            <div class="hero-left">
              <div class="hero-title">Happy Birthday, {{ employeeName }}! 🎂🎉</div>
              <div class="hero-subtitle">
                Wishing you a fantastic year ahead from all of us at {{ companyName }}.
              </div>
            </div>
            <div class="hero-right">
              <i class="pi pi-birthday-cake"></i>
            </div>
          </div>
        </div>
        <div class="leave-wfh-card">
          <div class="leave-wfh-header">
            <div class="header-left">
              <i class="pi pi-calendar-times cake-icon leave-icon"></i>
              <div>
                <h3>
                  <span *ngIf="todayLeaves.length > 1"> </span>On Leave Today
                </h3>
                <p *ngIf="todayLeaves.length > 0">
                  {{ todayLeaves.length }} employee{{ todayLeaves.length !== 1 ? 's' : '' }} on leave
                </p>
              </div>
            </div>
          </div>
          <div class="leave-wfh-list" *ngIf="todayLeaves.length > 0 && !loadingLeaves">
            <div *ngFor="let leave of todayLeaves" class="leave-wfh-item">
              <div class="leave-wfh-left">
                <img [src]="leave.image" [alt]="leave.employeeName" class="leave-wfh-avatar" />
              </div>
              <div class="leave-wfh-right">
                <div class="leave-wfh-name">{{ leave.employeeName }}</div>
                <div class="leave-wfh-designation">{{ leave.designation }}</div>
                <div class="leave-wfh-meta">
                  <span class="leave-type-badge" [ngClass]="getLeaveTypeClass(leave.leaveType)">
                    {{ leave.leaveType }}
                  </span>
                  <span class="duration-badge" *ngIf="leave.leaveDuration"
                    [ngClass]="getDurationClass(leave.leaveDuration)">
                    <i [class]="getDurationIcon(leave.leaveDuration)"></i>
                    {{ leave.leaveDuration }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="no-birthday" *ngIf="todayLeaves.length === 0 && !loadingLeaves">
            <span class="title">No employees on leave today</span>
            <span class="subtitle">Everyone is present!</span>
          </div>
          <div class="loading-state" *ngIf="loadingLeaves">
            <i class="pi pi-spin pi-spinner"></i>
            <p>Loading...</p>
          </div>
        </div>
        <div class="greeting-card">
          <div class="branding-section">
            <img [src]="companyLogo || 'assets/default-logo.png'" alt="Company Logo" class="company-logo" />
          </div>
          <div class="greeting-text">
            <h3>{{ greeting }}, <span class="username-highlight">{{ employeeName }}</span></h3>
            <p>{{ quote }}</p>
          </div>
        </div>
        <div class="birthday-card">
          <div class="birthday-header">
            <div class="header-left">
              <i class="pi pi-birthday-cake cake-icon"></i>
              <h3>🎉 Birthday Buddies</h3>
              <p *ngIf="selectedBirthdayFilter === 'today'">
                Today: {{ birthdaysToday.length }} celebrating
              </p>
              <p *ngIf="selectedBirthdayFilter === 'month'">
                This Month: {{ filteredBirthdays.length }} celebrating
              </p>
            </div>
            <div class="header-right">
              <p-dropdown [options]="birthdayOptions" [(ngModel)]="selectedBirthdayFilter"
                (onChange)="filterBirthdayList(true)">
              </p-dropdown>
            </div>
          </div>
          <div class="birthday-list" *ngIf="filteredBirthdays.length > 0">
            <div *ngFor="let emp of filteredBirthdays" class="birthday-item">
              <div class="birthday-left">
                <img [src]="emp.image" [alt]="emp.name" class="birthday-avatar" />
              </div>
              <div class="birthday-right">
                <div class="birthday-name">{{ emp.name }}</div>
                <div class="birthday-dob">
                  {{ emp.dob ? (emp.dob | date:'MMM d, y') : '—' }}
                </div>
              </div>
            </div>
          </div>
          <div class="no-birthday" *ngIf="filteredBirthdays.length === 0 && selectedBirthdayFilter === 'today'">
            <span class="title">No birthdays today! 🎈</span>
            <span class="subtitle">But celebrations are on the way 🎂</span>
          </div>
          <div class="no-birthday" *ngIf="filteredBirthdays.length === 0 && selectedBirthdayFilter === 'month'">
            <span class="title">No birthdays for this month 😎</span>
            <span class="subtitle">But don't worry, the party isn't far away 🎂</span>
          </div>
        </div>
      </div>
    </div>
    <p-toast></p-toast>
    <p-confirmDialog></p-confirmDialog>
  </p-tabPanel>
  <p-tabPanel styleClass="custom-tab">
    <ng-template pTemplate="header">
      <span class="custom-tab-header">
        My Feeds
        <span class="notif-badge tab-notif" *ngIf="totalFeedCount > 0">
          {{ totalFeedCount }}
        </span>
      </span>
    </ng-template>
    <div class="feeds-container">

      <div class="feed-card">
        <div class="feed-card-header">
          <div class="feed-header-left">
            <div class="feed-icon announcement-icon"><i class="pi pi-megaphone"></i></div>
            <div style="position: relative;">
              <h3>
                Announcements
                <span class="notif-badge" *ngIf="newAnnouncementsCount > 0">
                  {{ newAnnouncementsCount }}
                </span>
              </h3>
              <p>{{ announcements.length }} active announcement{{ announcements.length !== 1 ? 's' : '' }}</p>
            </div>
          </div>
        </div>
        <div class="feed-list" *ngIf="announcements.length > 0">
          <div class="feed-item" *ngFor="let item of announcements">
            <div class="feed-dot dot-ann"></div>
            <div class="feed-item-content">
              <div class="feed-item-title">{{ item.title }}</div>
              <div class="feed-item-meta">
                <span class="feed-item-date">
                  <i class="pi pi-calendar"></i> Posted: {{ item.date | date:'dd MMM yyyy' }}
                </span>
                <span class="feed-item-date" *ngIf="item.expiryDate">
                  <i class="pi pi-clock"></i> Expires: {{ item.expiryDate | date:'dd MMM yyyy' }}
                </span>
              </div>
            </div>
            <div class="feed-badge-group">
              <span class="feed-badge announcement-badge">{{ item.category || 'General' }}</span>
              <button class="view-btn" (click)="openDetail('announcement', item)">
                <i class="pi pi-eye"></i> View
              </button>
            </div>
          </div>
        </div>
        <div class="feed-empty" *ngIf="announcements.length === 0">
          <i class="pi pi-megaphone"></i>
          <span class="title">No announcements right now</span>
          <span class="subtitle">Check back later for updates</span>
        </div>
      </div>

      <div class="feed-card">
        <div class="feed-card-header">
          <div class="feed-header-left">
            <div class="feed-icon survey-icon"><i class="pi pi-chart-bar"></i></div>
            <div style="position: relative;">
              <h3>
                Surveys
                <span class="notif-badge survey-notif" *ngIf="newSurveysCount > 0">
                  {{ newSurveysCount }}
                </span>
              </h3>
              <p>{{ surveys.length }} survey{{ surveys.length !== 1 ? 's' : '' }} available</p>
            </div>
          </div>
        </div>
        <div class="feed-list" *ngIf="surveys.length > 0">
          <div class="feed-item" *ngFor="let item of surveys">
            <div class="feed-dot dot-sur"></div>
            <div class="feed-item-content">
              <div class="feed-item-title">{{ item.title }}</div>
              <div class="feed-item-meta">
                <span class="feed-item-date" *ngIf="item.startDate">
                  <i class="pi pi-play"></i> From: {{ item.startDate | date:'dd MMM yyyy' }}
                </span>
                <span class="feed-item-date" *ngIf="item.dueDate">
                  <i class="pi pi-flag"></i> Closes: {{ item.dueDate | date:'dd MMM yyyy' }}
                </span>
              </div>
            </div>
            <div class="feed-badge-group">
              <span class="feed-badge survey-badge" [ngClass]="{
                'badge-open':     item.status === 'Open',
                'badge-upcoming': item.status === 'Upcoming',
                'badge-closed':   item.status === 'Closed'
              }">{{ item.status }}</span>
              <button class="view-btn" (click)="openDetail('survey', item); markAsSeen(item)">
                <i class="pi pi-eye"></i> View
              </button>
            </div>
          </div>
        </div>
        <div class="feed-empty" *ngIf="surveys.length === 0">
          <i class="pi pi-chart-bar"></i>
          <span class="title">No open surveys</span>
          <span class="subtitle">You're all caught up!</span>
        </div>
      </div>
      <div class="feed-card full-width">
        <div class="feed-card-header">
          <div class="feed-header-left">
            <div class="feed-icon holiday-icon"><i class="pi pi-sun"></i></div>
            <div style="position: relative;">
              <h3>
                Upcoming Holidays
                <span class="notif-badge holiday-notif" *ngIf="newHolidaysCount > 0">
                  {{ newHolidaysCount }}
                </span>
              </h3>
              <p>{{ holidays.length }} upcoming holiday{{ holidays.length !== 1 ? 's' : '' }}</p>
            </div>
          </div>
        </div>
        <div class="feed-list holiday-grid" *ngIf="holidays.length > 0">
          <div class="feed-item" *ngFor="let item of holidays">
            <div class="feed-dot dot-hol"></div>
            <div class="feed-item-content">
              <div class="feed-item-title">{{ item.name }}</div>
              <div class="feed-item-meta">
                <span class="feed-item-date">
                  <i class="pi pi-calendar"></i> {{ item.date | date:'EEE, dd MMM yyyy' }}
                </span>
                <span class="feed-item-date" *ngIf="item.location">
                  <i class="pi pi-map-marker"></i> {{ item.location }}
                </span>
              </div>
            </div>
            <div class="feed-badge-group">
              <div style="display:flex;flex-direction:column;gap:4px;align-items:flex-end;">
                <span class="feed-badge holiday-badge" [ngClass]="{
                  'badge-national': item.type === 'National',
                  'badge-festival': item.type === 'Festival',
                  'badge-regional': item.type === 'Regional',
                  'badge-optional': item.type === 'Optional'
                }">{{ item.type }}</span>
                <span class="feed-badge badge-optional" *ngIf="item.isOptional">Optional</span>
              </div>
              <button class="view-btn" (click)="openDetail('holiday', item)">
                <i class="pi pi-eye"></i> View
              </button>
            </div>
          </div>
        </div>
        <div class="feed-empty" *ngIf="holidays.length === 0">
          <i class="pi pi-sun"></i>
          <span class="title">No upcoming holidays</span>
          <span class="subtitle">Stay tuned for updates</span>
        </div>
      </div>
    </div>
  </p-tabPanel>
  <p-dialog [(visible)]="showDetailDialog" [modal]="true" [style]="{ width: '520px' }" [draggable]="false"
    [resizable]="false" [closable]="true" (onHide)="closeDetail()">
    <ng-template pTemplate="header">
      <div class="detail-dialog-header">
        <span class="detail-dialog-type" [ngClass]="{
          'type-ann': detailType === 'announcement',
          'type-sur': detailType === 'survey',
          'type-hol': detailType === 'holiday'
        }">
          <i class="pi" [ngClass]="{
            'pi-megaphone': detailType === 'announcement',
            'pi-chart-bar': detailType === 'survey',
            'pi-sun':       detailType === 'holiday'
          }"></i>
          {{ detailType | titlecase }}
        </span>
        <span class="detail-dialog-title">{{ detailItem?.title || detailItem?.name }}</span>
      </div>
    </ng-template>
    <div class="detail-dialog-body" *ngIf="detailItem">
      <div class="detail-section">
        <label>Description</label>
        <p style="text-align: left !important;">{{ detailItem.description || '—' }}</p>
      </div>
      <ng-container *ngIf="detailType === 'announcement'">
        <div class="detail-row">
          <div class="detail-section" *ngIf="detailItem.date">
            <label><i class="pi pi-calendar"></i> Posted</label>
            <p style="text-align: left !important;">{{ detailItem.date | date:'dd MMM yyyy' }}</p>
          </div>
          <div class="detail-section" *ngIf="detailItem.expiryDate">
            <label><i class="pi pi-clock"></i> Expires</label>
            <p style="text-align: left !important;">{{ detailItem.expiryDate | date:'dd MMM yyyy' }}</p>
          </div>
          <div class="detail-section">
            <label><i class="pi pi-tag"></i> Category</label>
            <p style="text-align: left !important;">{{ detailItem.category || 'General' }}</p>
          </div>
        </div>
        <div class="detail-section mt-2" *ngIf="detailItem.attachment">
          <label><i class="pi pi-paperclip"></i> Attachment</label>
          <div>
            <a [href]="getAttachmentUrl(detailItem.attachment)" target="_blank" rel="noopener" class="attachment-btn">
              <i class="pi pi-eye"></i> View Attachment
            </a>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="detailType === 'survey'">
        <div class="detail-row">
          <div class="detail-section" *ngIf="detailItem.startDate">
            <label><i class="pi pi-play"></i> From</label>
            <p style="text-align: left !important;">{{ detailItem.startDate | date:'dd MMM yyyy' }}</p>
          </div>
          <div class="detail-section" *ngIf="detailItem.dueDate">
            <label><i class="pi pi-flag"></i> Closes</label>
            <p style="text-align: left !important;">{{ detailItem.dueDate | date:'dd MMM yyyy' }}</p>
          </div>
          <div class="detail-section">
            <label><i class="pi pi-info-circle"></i> Status</label>
            <p style="text-align: left !important;">{{ detailItem.status }}</p>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="detailType === 'holiday'">
        <div class="detail-row" style="justify-content: flex-start; gap: 2rem;"></div>
        <div class="detail-row">
          <div class="detail-section" *ngIf="detailItem.date">
            <label><i class="pi pi-calendar"></i> Date</label>
            <p style="text-align: left !important;">{{ detailItem.date | date:'EEE, dd MMM yyyy' }}</p>
          </div>
          <div class="detail-section" *ngIf="detailItem.location">
            <label><i class="pi pi-map-marker"></i> Location</label>
            <p style="text-align: left !important;">{{ detailItem.location }}</p>
          </div>
          <div class="detail-section">
            <label><i class="pi pi-tag"></i> Type</label>
            <p style="text-align: left !important;">{{ detailItem.type }}</p>
          </div>
        </div>
      </ng-container>
    </div>
    <ng-template pTemplate="footer">
      <p-button label="Close" icon="pi pi-times" severity="secondary" (click)="closeDetail()"></p-button>
    </ng-template>
  </p-dialog>
  <p-tabPanel header="Profile">
    <form [formGroup]="employeeForm" class="white-bg-form">
      <div class="grid">
        <div class="col-12">
          <p-fieldset legend="Basic Information" [toggleable]="true" [collapsed]="false">
            <div class="formgrid grid">
              <div class="field col-12 md:col-2 text-left">
                <label for="employeeId" class="label-required">Employee ID</label>
                <input pInputText placeholder="Employee ID" class="w-full p-inputtext-sm" formControlName="employeeId"
                  readonly />
              </div>
              <div class="field col-12 md:col-2 text-left">
                <label>Prefix</label>
                <p-dropdown formControlName="prefix" [options]="prefixOptions" styleClass="w-full" placeholder="Prefix"
                  [readonly]="true"></p-dropdown>
              </div>
              <div class="field col-12 md:col-4 text-left">
                <label class="label-required">First Name</label>
                <input pInputText placeholder="First Name" class="w-full p-inputtext-sm" formControlName="firstName"
                  readonly />
              </div>
              <div class="field col-12 md:col-4 text-left">
                <label>Last Name</label>
                <input pInputText placeholder="Last Name" class="w-full p-inputtext-sm" formControlName="lastName"
                  readonly />
              </div>
              <div class="field col-12 md:col-3 text-left">
                <label>Gender</label>
                <p-dropdown formControlName="gender" [options]="gender" placeholder="Select Gender" styleClass="w-full"
                  [readonly]="true"></p-dropdown>
              </div>
              <div class="field col-12 md:col-3 text-left">
                <label>Date of Birth</label>
                <input type="text" class="w-full p-inputtext p-component"
                  [value]="employeeForm.get('dob')?.value | date:'dd/MM/yyyy'" readonly placeholder="—" />
              </div>
              <div class="field col-12 md:col-3 text-left">
                <label>Phone</label>
                <input pInputText placeholder="Phone" class="w-full p-inputtext-sm" formControlName="phone" readonly />
              </div>
              <div class="field col-12 md:col-3 text-left">
                <label>Mobile</label>
                <input pInputText placeholder="Mobile" class="w-full p-inputtext-sm" formControlName="mobile"
                  readonly />
              </div>
              <div class="field col-12 md:col-6 text-left">
                <label class="label-required">Email</label>
                <input pInputText placeholder="Email" class="w-full p-inputtext-sm" formControlName="email" readonly />
              </div>
              <div class="field col-12 md:col-3 text-left">
                <label>Facebook</label>
                <input pInputText placeholder="Facebook" class="w-full p-inputtext-sm" formControlName="facebook"
                  readonly />
              </div>
              <div class="field col-12 md:col-3 text-left">
                <label>X (Twitter)</label>
                <input pInputText placeholder="Twitter" class="w-full p-inputtext-sm" formControlName="twitter"
                  readonly />
              </div>
              <div class="field col-12 text-left" formGroupName="address">
                <label class="label-required">Address</label>
                <input pInputText placeholder="Street Address" class="w-full p-inputtext-sm"
                  formControlName="addressLine1" readonly />
                <input pInputText placeholder="Street Address 2" class="w-full p-inputtext-sm mt-1"
                  formControlName="addressLine2" readonly />
                <div class="flex mt-1">
                  <div>
                    <input pInputText placeholder="City" class="w-full p-inputtext-sm" formControlName="city"
                      readonly />
                  </div>
                  <div class="ml-1">
                    <p-autoComplete placeholder="State" formControlName="state" field="stateName"
                      [readonly]="true"></p-autoComplete>
                  </div>
                  <div class="ml-1">
                    <input pInputText placeholder="Zip" class="w-full p-inputtext-sm" formControlName="zip" readonly />
                  </div>
                </div>
                <input pInputText placeholder="Country" class="w-full p-inputtext-sm mt-1" formControlName="country"
                  readonly />
              </div>
            </div>
          </p-fieldset>
        </div>
        <div class="col-12">
          <p-fieldset legend="Work Information" [toggleable]="true" [collapsed]="false">
            <div class="formgrid grid">
              <div class="field col-12 md:col-3 text-left">
                <label>Designation</label>
                <input pInputText placeholder="Designation" class="w-full p-inputtext-sm" formControlName="designation"
                  readonly />
              </div>
              <div class="field col-12 md:col-3 text-left">
                <label>Job Role</label>
                <input pInputText placeholder="Job Role" class="w-full p-inputtext-sm" formControlName="jobRole"
                  readonly />
              </div>
              <div class="field col-12 md:col-3 text-left">
                <label>Work Email</label>
                <input pInputText placeholder="Work Email" class="w-full p-inputtext-sm" formControlName="work_Email"
                  readonly />
              </div>
              <div class="field col-12 md:col-3 text-left">
                <label>Employment Type</label>
                <input pInputText placeholder="Employment Type" class="w-full p-inputtext-sm"
                  formControlName="employmentType" readonly />
              </div>
              <div class="field col-12 md:col-3 text-left">
                <label>Employee Status</label>
                <input pInputText placeholder="Employee Status" class="w-full p-inputtext-sm"
                  formControlName="employeeStatus" readonly />
              </div>
              <div class="field col-12 md:col-3 text-left">
                <label>Location</label>
                <input pInputText placeholder="Location" class="w-full p-inputtext-sm" formControlName="location"
                  readonly />
              </div>
              <div class="field col-12 md:col-3 text-left">
                <label>Date of Joining</label>
                <input type="text" class="w-full p-inputtext p-component"
                  [value]="employeeForm.get('dateOfJoining')?.value | date:'dd/MM/yyyy'" readonly placeholder="—" />
              </div>
              <div class="field col-12 md:col-3 text-left">
                <label>Shift</label>
                <p-dropdown formControlName="ShiftId" [options]="shiftDropdown" optionLabel="label"
                  optionValue="shiftId" placeholder="Select Shift" styleClass="w-full" [readonly]="true">
                </p-dropdown>
              </div>
              <div class="field col-12 md:col-4 text-left">
                <label>Reporting Managers</label>
                <p-multiSelect [options]="employeeList" formControlName="reportingManager"
                  placeholder="Select Reporting Managers" [maxSelectedLabels]="10" class="w-full p-inputtext-sm"
                  [readonly]="true">
                </p-multiSelect>
              </div>
            </div>
          </p-fieldset>
        </div>
        <div class="col-12">
          <p-fieldset legend="Education Details" [toggleable]="true" [collapsed]="false">
            <div class="formgrid grid">
              <div class="field col-12 md:col-6 text-left">
                <label>Institute Name</label>
                <input pInputText placeholder="Institute Name" class="w-full p-inputtext-sm"
                  formControlName="instituteName" readonly />
              </div>
              <div class="field col-12 md:col-3 text-left">
                <label>Degree</label>
                <input pInputText placeholder="Degree" class="w-full p-inputtext-sm" formControlName="degree"
                  readonly />
              </div>
              <div class="field col-12 md:col-3 text-left">
                <label>Specialization</label>
                <input pInputText placeholder="Specialization" class="w-full p-inputtext-sm"
                  formControlName="specialization" readonly />
              </div>
              <div class="field col-12 md:col-3 text-left">
                <label>Completion Year</label>
                <input pInputText placeholder="YYYY" class="w-full p-inputtext-sm" formControlName="completionYear"
                  readonly />
              </div>
              <div class="field col-12 text-left">
                <label>Internal Notes</label>
                <textarea rows="2" pInputTextarea formControlName="internalNotes" class="w-full p-inputtext-sm"
                  readonly></textarea>
              </div>
            </div>
          </p-fieldset>
        </div>
      </div>
      <p-toast></p-toast>
    </form>
  </p-tabPanel>

  <p-tabPanel header="Files">
    <div class="files-container">

      <div class="files-toolbar">
        <div class="files-search-wrap">
          <i class="pi pi-search files-search-icon"></i>
          <input pInputText type="text" placeholder="Search files…" class="files-search-input"
            [(ngModel)]="fileSearchQuery" (input)="onFileSearch()" />
        </div>
        <div class="files-filter-chips">
          <span *ngFor="let f of fileFilters" class="filter-chip" [class.active]="activeFileFilter === f.value"
            (click)="setFileFilter(f.value)">
            <i [class]="f.icon"></i> {{ f.label }}
          </span>
        </div>

        <input type="file" #fileInput multiple style="display:none" (change)="onFilesSelected($event)" />
      </div>


      <div class="files-section">
        <div class="files-section-header">
          <div class="section-label">
            <i class="pi pi-folder-open"></i>
            <span>My Uploads</span>
            <span class="section-count">{{ filteredMyFiles.length }}</span>
          </div>

          <!-- Right side: Submit button + Grid/List toggle -->
          <div style="display: flex; align-items: center; gap: 0.5rem;">

            <!-- SUBMIT button beside "My Uploads" -->
            <button pButton type="button" label="Submit" icon="pi pi-send" class="p-button-sm p-button-success"
              (click)="submitFiles()">
            </button>

            <!-- Grid / List toggle — shared across My Uploads + Shared With Me -->
            <div class="view-toggle">
              <button class="view-btn" [class.active]="myFilesView==='grid'" (click)="myFilesView='grid'">
                <i class="pi pi-th-large"></i>
              </button>
              <button class="view-btn" [class.active]="myFilesView==='list'" (click)="myFilesView='list'">
                <i class="pi pi-list"></i>
              </button>
            </div>
          </div>
        </div>

     
         <!-- GRID VIEW: Upload + View buttons per card (Download removed) -->
        <div class="files-grid" *ngIf="myFilesView === 'grid' && filteredMyFiles.length > 0">
          <div class="file-card" *ngFor="let file of filteredMyFiles">
            <div class="file-card-icon" [ngClass]="getFileColorClass(file.type)">
              <i [class]="getFileIcon(file.type)"></i>
            </div>
            <div class="file-card-info">
              <div class="file-name" [title]="file.name">{{ file.name }}</div>
              <div class="file-meta" *ngIf="file.uploadedAt">{{ file.size }} · {{ file.uploadedAt | date:'dd MMM yyyy' }}</div>
              <span class="submitted-badge" *ngIf="file.submitted">
                <i class="pi pi-check-circle"></i> Submitted
              </span>
            </div>
            <div class="file-card-actions" (click)="$event.stopPropagation()">
              <button pButton type="button" icon="pi pi-upload"
                class="p-button-text p-button-sm file-action-btn" pTooltip="Upload" (click)="uploadFile(file)"></button>
              <button pButton type="button" icon="pi pi-trash"
                class="p-button-text p-button-sm p-button-danger file-action-btn" pTooltip="Remove" (click)="clearFile(file)"></button>
            </div>
          </div>
        </div>

        <!-- LIST VIEW: Upload + View buttons per row (Download removed) -->
        <div class="files-list" *ngIf="myFilesView === 'list' && filteredMyFiles.length > 0">
          <div class="file-row" *ngFor="let file of filteredMyFiles">
            <div class="file-row-icon" [ngClass]="getFileColorClass(file.type)">
              <i [class]="getFileIcon(file.type)"></i>
            </div>
            <div class="file-row-name">
              {{ file.name }}
              <span class="submitted-badge" *ngIf="file.submitted">
                <i class="pi pi-check-circle"></i> Submitted
              </span>
            </div>
            <div class="file-row-size" *ngIf="file.uploadedAt">{{ file.size }}</div>
            <div class="file-row-date" *ngIf="file.uploadedAt">{{ file.uploadedAt | date:'dd MMM yyyy' }}</div>
            <div class="file-row-actions" (click)="$event.stopPropagation()">
              <button pButton type="button" icon="pi pi-upload"
                class="p-button-text p-button-sm file-action-btn" pTooltip="Upload" (click)="uploadFile(file)"></button>
              <button pButton type="button" icon="pi pi-trash"
                class="p-button-text p-button-sm p-button-danger file-action-btn" pTooltip="Remove" (click)="clearFile(file)"></button>
            </div>
          </div>
        </div>


        <div class="files-empty" *ngIf="filteredMyFiles.length === 0">
          <i class="pi pi-inbox"></i>
          <span class="title">No documents found</span>
          <span class="subtitle">Try adjusting your search or filter</span>
        </div>
      </div>

      <div class="files-section">
        <div class="files-section-header">
          <div class="section-label">
            <i class="pi pi-users"></i>
            <span>Shared With Me</span>
            <span class="section-count">{{ filteredSharedFiles.length }}</span>
          </div>
        </div>

        <!-- GRID VIEW -->
        <div class="files-grid" *ngIf="myFilesView === 'grid' && filteredSharedFiles.length > 0">
          <div class="file-card shared" *ngFor="let file of filteredSharedFiles" (click)="openFile(file)">
            <div class="file-card-icon" [ngClass]="getFileColorClass(file.type)">
              <i [class]="getFileIcon(file.type)"></i>
            </div>
            <div class="file-card-info">
              <div class="file-name" [title]="file.name">{{ file.name }}</div>
              <div class="file-meta">{{ file.size }} · {{ file.uploadedAt | date:'dd MMM yyyy' }}</div>
              <div class="shared-by">
                <i class="pi pi-user"></i> {{ file.sharedBy }}
              </div>
            </div>
            <div class="file-card-actions" (click)="$event.stopPropagation()">
              <button pButton type="button" icon="pi pi-eye" class="p-button-text p-button-sm file-action-btn"
                pTooltip="View" (click)="openFile(file)"></button>
              <button pButton type="button" icon="pi pi-download" class="p-button-text p-button-sm file-action-btn"
                pTooltip="Download" (click)="downloadFile(file)"></button>
            </div>
          </div>
        </div>

        <!-- LIST VIEW -->
        <div class="files-list" *ngIf="myFilesView === 'list' && filteredSharedFiles.length > 0">
          <div class="file-row shared" *ngFor="let file of filteredSharedFiles" (click)="openFile(file)">
            <div class="file-row-icon" [ngClass]="getFileColorClass(file.type)">
              <i [class]="getFileIcon(file.type)"></i>
            </div>
            <div class="file-row-name">{{ file.name }}</div>
            <div class="file-row-size">{{ file.size }}</div>
            <div class="file-row-date">{{ file.uploadedAt | date:'dd MMM yyyy' }}</div>
            <div class="file-row-shared-by">
              <i class="pi pi-user"></i> {{ file.sharedBy }}
            </div>
            <div class="file-row-actions" (click)="$event.stopPropagation()">
              <button pButton type="button" icon="pi pi-eye" class="p-button-text p-button-sm file-action-btn"
                pTooltip="View" (click)="openFile(file)"></button>
              <button pButton type="button" icon="pi pi-download" class="p-button-text p-button-sm file-action-btn"
                pTooltip="Download" (click)="downloadFile(file)"></button>
            </div>
          </div>
        </div>

        <div class="files-empty" *ngIf="filteredSharedFiles.length === 0">
          <i class="pi pi-share-alt"></i>
          <span class="title">No files shared with you</span>
          <span class="subtitle">Files shared by colleagues will appear here</span>
        </div>
      </div>


    </div>
  </p-tabPanel>
  <!-- ============================================================
       FILES TAB — END
       ============================================================ -->

  <p-tabPanel header="Calendar">
    <p-card class="w-full">
      <div class="full-calendar-wrapper mt-3">
        <full-calendar [options]="calendarOptions"></full-calendar>
      </div>
    </p-card>
    <p-toast></p-toast>
  </p-tabPanel>
  <p-tabPanel header="Expense & Reimbursement">
    <p-card header="">
      <div class="">
        <div class="summary-grid" style="grid-template-columns: repeat(5, 1fr); gap: 0.75rem; margin: 1rem 0;">
          <div class="summary-card" style="padding: 1rem 1.25rem; min-height: unset;">
            <h5 style="font-size: 0.85rem; margin: 0 0 0.4rem 0;">Approved Amount</h5>
            <h2 style="font-size: 1.6rem; margin: 0;">₹ {{ dashboardData.approvedAmount | number:'1.0-0' }}</h2>
          </div>
          <div class="summary-card" style="padding: 1rem 1.25rem; min-height: unset;">
            <h5 style="font-size: 0.85rem; margin: 0 0 0.4rem 0;">Pending Amount</h5>
            <h2 style="font-size: 1.6rem; margin: 0;">₹ {{ dashboardData.pendingAmount | number:'1.0-0' }}</h2>
          </div>
          <div class="summary-card" style="padding: 1rem 1.25rem; min-height: unset;">
            <h5 style="font-size: 0.85rem; margin: 0 0 0.4rem 0;">Rejected Amount</h5>
            <h2 style="font-size: 1.6rem; margin: 0;">₹ {{ dashboardData.rejectedAmount | number:'1.0-0' }}</h2>
          </div>
          <div class="summary-card" style="padding: 1rem 1.25rem; min-height: unset;">
            <h5 style="font-size: 0.85rem; margin: 0 0 0.4rem 0;">Total Applied Amount</h5>
            <h2 style="font-size: 1.6rem; margin: 0;">₹ {{ dashboardData.claimAmount | number:'1.0-0' }}</h2>
          </div>
          <div class="summary-card" style="padding: 1rem 1.25rem; min-height: unset;">
            <h5 style="font-size: 0.85rem; margin: 0 0 0.4rem 0;">Total Paid Amount</h5>
            <h2 style="font-size: 1.6rem; margin: 0;">₹ {{ dashboardData.paidAmount | number:'1.0-0' }}</h2>
          </div>
        </div>

        <div class="flex align-items-center mb-1" style="gap: 0.5rem;">


          <div class="flex align-items-center mb-3" style="gap: 0.5rem; position: relative;">
            <p-button label="New" class="p-button-outlined" icon="pi pi-plus-circle" size="small"
              (click)="addNewExpense()" pTooltip="Create New Expense">
            </p-button>
            <span class="p-input-icon-left" style="width: 200px;">
              <i class="pi pi-search"></i>
              <input pInputText type="text" [(ngModel)]="searchText" placeholder="Search Expense..."
                class="p-inputtext-sm w-full" (keyup.enter)="searchExpense()"
                style="height: 35px; font-size: 0.875rem; padding-left: 2rem;" />
            </span>
            <p-button icon="pi pi-search" (click)="searchExpense()" [raised]="true" size="small" severity="info"
              [ngStyle]="{ height: '35px' }">
            </p-button>
          </div>


          <h2 style="position: absolute; left: 50%; transform: translateX(-0%);
             margin: 0; font-weight: 700; color: #000000; font-size: 1.7rem;">
            Expense List
          </h2>

          <div style="margin-left: auto;flex-shrink: 0;">
            <p-button icon="pi pi-refresh" size="small" (click)="refreshExpenseData()" [rounded]="true" severity="info">
            </p-button>
          </div>

        </div>
        <p-table #expDt [value]="recentExpenses" [lazy]="false" dataKey="id" [scrollable]="true" scrollHeight="613px"
          styleClass="p-datatable-striped p-datatable-sm" responsiveLayout="scroll" class="w-full m-5"
          [paginator]="true" [rows]="10" [(selection)]="selectedExpense"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
          [rowsPerPageOptions]="[10, 15, 20]">
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 4rem">
                <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
              </th>
              <th>Expense Type</th>
              <th>Expense Date</th>
              <th>Amount</th>
              <th class="advance-col">Advance Amount</th>
              <th>Description</th>
              <th>Status</th>
              <th>Created Date</th>
              <th>Created By</th>
              <th>Reviewed By</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-expense>
            <tr>
              <td>
                <p-tableCheckbox [value]="expense"></p-tableCheckbox>
              </td>
              <td class="text-blue-500 underline" style="cursor: pointer;" (click)="openExpenseDetail(expense)">
                <span>
                  <i [class]="getExpenseTypeIcon(expense.expenseType)" class="mr-1"></i>
                  {{ expense.expenseType }}
                </span>
              </td>
              <td>{{ expense.expenseDate | date: 'dd/MM/yyyy' }}</td>
              <td>₹ {{ expense.amount | number:'1.0-0' }}</td>
              <td class="advance-col">
                <span class="advance-badge">
                  {{ expense.isAdvanceReceived ? 'Yes' : 'No' }}
                </span>
              </td>
              <td class="wrap-text">{{ expense.description }}</td>
              <td [ngClass]="{
                'status-pending':  expense.status === 'Submitted',
                'status-approved': expense.status === 'Approved',
                'status-rejected': expense.status === 'Rejected',
                'status-paid':     expense.status === 'Paid',
                'status-draft':    expense.status === 'Draft'
              }">
                {{ expense.status }}
              </td>
              <td>{{ expense.createdDate | date: 'dd/MM/yyyy' }}</td>
              <td>{{ expense.createdBy || '-' }}</td>
              <td>{{ expense.reviewedBy || '-' }}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="10">No Records found.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-card>


  </p-tabPanel>
</p-tabView>
<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>